import axios from "axios";
import axiosWL from "./axios-wl.js";
import { mimeTypes } from "./s3uploadMimeTypes.js";

const BASE_URL = "https://api.classplusapp.com";
const token =
	"eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJpZCI6Mjg5OTk0LCJvcmdJZCI6MTcwLCJ0eXBlIjozLCJtb2JpbGUiOiI5MTk3MTExNTMwNzkiLCJuYW1lIjoiR3VuamFuIEd1cHRhIHBybyB0dXRvciBsZWFybiIsImVtYWlsIjoibWFuYW5AY2xhc3NwbHVzLmNvIiwiaWF0IjoxNjM5OTc3MDEyLCJleHAiOjE2NDA1ODE4MTJ9.8mwIIcG52q6EaNDqC-IvldeyxM_SocxB7lvH3PAE928EQW7tcBTw6IryVyURed-F";

export default async function s3Upload(files) {
	let publicId = makeId(20);
	const headers = {
		"content-type": "application/json",
		"x-access-token": token,
	};

	let fileExtensions = files.map((file, index) => {
		return {
			name: getFileExtension(file.name),
			id: index + 1,
		};
	});
	let url = `v2/users/getS3SignedUrl`;
	return axios({
		url,
		method: "POST",
		data: { exts: fileExtensions },
		baseURL: BASE_URL,
		undefined,
		headers: headers,
	})
		.then((response) => {
			const signedUploadUrls = response.data.data;
			const downloadUrls = response.data.data.map((ob) => {
				return {
					url: ob.publicUrl,
					fileName: "",
					public_id: "",
					format: "",
				};
			});
			let successUrls = [];
			let fileData = files.map((file, index) => {
				downloadUrls[index].fileName = file.name;
				downloadUrls[index].format = getFileExtension(file.name).toLowerCase();
				downloadUrls[index].public_id = publicId;
				return {
					...file,
					uploadSignedUrl: signedUploadUrls[index].uploadSignedUrl,
				};
			});
			let uploadedCount = 0;
			let errorCount = 0;
			let rejectFileIds = [];
			return new Promise((resolve, reject) => {
				fileData.forEach((file, i) => {
					let options = {
						headers: {
							"content-type": getMimeType(files[i]),
						},
					};
					axiosWL
						.put(file.uploadSignedUrl, files[i], options)
						.then((res) => {
							uploadedCount = uploadedCount + 1;
							successUrls.push(downloadUrls[i]);
							if (
								successUrls.length + rejectFileIds.length ===
								fileData.length
							) {
								resolve(successUrls);
							}
						})
						.catch((e) => {
							errorCount = errorCount + 1;
							rejectFileIds.push(i);
							if (
								successUrls.length + rejectFileIds.length ===
								fileData.length
							) {
								resolve(successUrls);
							}
						});
				});
			});
		})
		.catch((err) => console.log(err));
}
function getFileExtension(filename) {
	return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
}
const makeId = (length) => {
	var result = "";
	var characters =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
};
function getMimeType(file) {
	let ext = getFileExtension(file.name);
	return mimeTypes[ext];
}
